// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trf-cardTotalizador-usuario-nome[data-v-0ee137f4] {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  box-orient: vertical;\n  overflow: hidden;\n}\n.trf-cardTotalizador-totalizadores-item > div a[data-v-0ee137f4] {\n  color: hsl(0deg, 0%, 29%) !important;\n}", ""]);
// Exports
module.exports = exports;
